import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';


export default Backbone.View.extend({
  events: {
    click: 'open_detail'
  },
  initialize: function (options) {
    _.bindAll(this, 'render', 'open_detail', 'user_status_changed');

    this.template = _.template($('#coach-tmpl').html());
    this.coachhub = options.coachhub;

    this.render();

    this.coachhub.on('user-online user-offline', this.user_status_changed);
  },
  render: function () {
    var data = { coach: this.model, domains: this.coachhub.domains };
    this.$el.html(this.template(data));
  },
  open_detail: function (e) {
    this.coachhub.coach_detail_view.set_coach(this.model);
  },
  user_status_changed: function (data) {
    // A user's status changed. If it's me, fetch the latest information and rerender
    if (this.model.get('user').url != data.user) {
      return;
    }
    this.model.fetch({ cache: false, success: _.bind(function () {
      // The backbone-fetch-cache library only clears the cache here if the method is
      // create, update, patch or delete. Since we are doing a read, we need to clear it
      // ourselves.
      Backbone.fetchCache.clearItem(COACHES_API_URL);
      this.render();
    }, this) });
  }
});



// WEBPACK FOOTER //
// ./static/js/views/coach.js